<template>
    <v-container class="py-3 px-3">
        <v-row class="pa-0 ma-0" justify="center">
            <v-col lg="3" md="4" sm="6" class="py-0">
                <v-card class="background-2" elevation="0">
                    <v-card-text class="text-center pa-0">
                        <v-icon color="blue" size="28" class="mb-1">mdi-package-variant</v-icon>
                        <div class="text-caption">Totale Quantità</div>
                        <div style="font-size: 16px !important" class="text-h6 font-weight-bold blue--text">{{ totalQuantity }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" class="py-0">
                <v-card class="background-2" elevation="0">
                    <v-card-text class="text-center pa-0">
                        <v-icon color="teal" size="28" class="mb-1">mdi-check-circle-outline</v-icon>
                        <div class="text-caption">Totale Quantità convertita</div>
                        <div style="font-size: 16px !important" class="text-h6 font-weight-bold teal--text">{{ totalUnloadQuantity }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" class="py-0">
                <v-card class="background-2" elevation="0">
                    <v-card-text class="text-center pa-0">
                        <v-icon color="orange darken-1" size="28" class="mb-1">mdi-clock-outline</v-icon>
                        <div class="text-caption">Totale Quantità da convertire</div>
                        <div style="font-size: 16px !important" class="text-h6 font-weight-bold orange--text text--darken-1">{{ totalQuantity - totalUnloadQuantity }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" class="py-0">
                <v-card class="background-2" elevation="0">
                    <v-card-text class="text-center pa-0">
                        <v-icon color="green" size="28" class="mb-1">mdi-currency-eur</v-icon>
                        <div class="text-caption">Imponibile</div>
                        <div style="font-size: 16px !important" class="text-h6 font-weight-bold green--text">€ {{ totalPrice.toFixed(2) }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: 'footer-product-purchaseddt-table',
    props: {
        type: String,
        items: Array,
        parent: Object,
        fieldsset: Array,
    },
    data() {
        return {
        }
    },

    computed: {
        totalQuantity() {
            return this.items.reduce((acc, product) => acc + (parseFloat(product.quantity) || 0), 0)
        },

        totalUnloadQuantity() {
            return this.items.reduce((acc, product) => acc + (parseFloat(product.unload_quantity) || 0), 0)
        },

        // Imponibile netto: subtotal di testata salvato dal backend (prepareDocument),
        // altrimenti somma del netto di riga con la stessa cascata di sconti
        // di CrudTableRelationship.calcItemNetPrice
        totalPrice() {
            if (this.parent && typeof this.parent.subtotal === 'number') {
                return this.parent.subtotal
            }
            return this.items.reduce((acc, product) => acc + this.netLine(product), 0)
        }
    },

    methods: {
        netLine(item) {
            let price = parseFloat(item.purchase_price) || 0
            for (let j = 1; j <= 5; j++) {
                if (typeof item['discount' + j] === 'number' && item['discount' + j] > 0) {
                    price = price * (100 - item['discount' + j]) / 100
                }
            }
            const globalDiscount = this.parent && typeof this.parent.global_discount === 'number' ? this.parent.global_discount : 0
            if (globalDiscount > 0) {
                price = price * (100 - globalDiscount) / 100
            }
            const quantity = parseFloat(item.quantity) || 0
            return Math.round(((price * quantity) + Number.EPSILON) * 100) / 100
        }
    },

}
</script>

<style scoped>



</style>